<script>
    import { Nav, NavItem, NavLink } from 'sveltestrap'
    import { sessionLogout } from '@fno/service/api/authentication.js'
    export let asr
</script>

<footer class="footer mt-auto py-3">
    <hr class="fno-menu-hr" />
    <Nav vertical pills>
        <NavItem>
            <NavLink
                href="https://fromnowon.freshdesk.com/support/solutions/articles/35000175543-getting-started-portal-onboarding"
                target="_blank"
            >
                Help
            </NavLink>
        </NavItem>
        <NavItem>
            <!-- Use Bootstrap native instead of NavLink so we can use on: handlers-->
            <a class="nav-link" href={asr.makePath('login')} on:click|preventDefault={sessionLogout}> Sign Out </a>
        </NavItem>
    </Nav>
</footer>
